<template>
    <v-img :src="`/api2/resource/ConvertUrlToQrCodeImage?url=${url}`" :height="size" :width="size">
    </v-img>
</template>


<script>

export default {
    name: 'Qr',
    props: {
        url: String,
        size: {
            type: Number,
            default: 100,
        },
    },
    components: {
    },

    data() {
        return {
        };
    },


    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>